import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link} from "react-router-dom";
import { Grid } from "@material-ui/core";
import { withStyles, withTheme } from "@material-ui/core/styles";
import styled from "styled-components";
import {
  addFeatureImageToDeal,
  createDeal,
  clearNewDealId
} from "store/state/deal";
import { ToastError } from "components/Global/Toasts/Toasty";
import NewDealHeader from "./NewDealHeader";
import AssetDetails from "./Sections/AssetDetails";
import Styles from "../Global/Fields/styles";
import { PIPELINE } from "constants/status";
import dealStages from "constants/dealStages";
import BreadCrumbGrid from 'components/Global/BreadCrumb/BreadCrumbGrid'

const styles = () => ({});

const PaddedContainer = styled.div`
  padding: 10px 55px;
`;

const OrganicLink = ({to, targetId, children, placeholder, ...other}) => {
  if(targetId === 'free')
    return null;
  return <Link to={to} {...other}>{children}</Link>  
}

class NewPipelineDeal extends React.Component {
  state = {
    deal: {
      properties: []
    },
    dealError: {
      name: false,
      fundId: false
    },
    isNewDeal: true,
    isEditing: true,
    isInitialized: false,
    showStageField: true
  };

  componentDidMount() {
    this.setState({
      deal: {
        dealStatusId: `${PIPELINE}`,
        stageId: `${dealStages.SOFT_QUOTE}`,
        properties: [],
        isPipeline:true
      }
    });
  };

  componentDidUpdate() {
    if (this.props.deal.newDealId) {
      this.props.clearNewDealId(this.props.deal.newDealId);
      if(this.state.deal.isPipeline){
        this.props.history.push(
          `pipeline/active/deals/${this.props.deal.newDealId}`
        );
      } else {
        this.props.history.push(`portfolio/funds/${this.state.deal.fundId}/deals/${this.props.deal.newDealId}`)
      }
    }
  };

  handleDealStatusSelected = data => {
    const dealStatusId = data.value;
    const isPipeline = dealStatusId === PIPELINE;
    const showStageField = isPipeline;
    const stageId = isPipeline ? `${dealStages.SOFT_QUOTE}` : null;

    this.setState({
      showStageField,
      deal: {
        ...this.state.deal,
        isPipeline,
        dealStatusId,
        stageId
      }
    });
  };

  handleChange = (name, data) => {
    let dealError = { ...this.state.dealError };
    if (dealError[name] && data.value) {
      dealError[name] = false;
    }
    this.setState({
      deal: { ...this.state.deal, [name]: data.value },
      dealError
    });

    if (name === "dealStatusId") {
      this.handleDealStatusSelected(data);
    }
  };

  cancel = () => {
    this.props.history.goBack();
  };

  handleTextChange = ({ target: { name, value } }) => {
    let dealError = { ...this.state.dealError };
    if (dealError[name] && value) {
      dealError[name] = false;
    }
    this.setState({
      deal: {
        ...this.state.deal,
        [name]: value
      },
      dealError
    });
  };

  handleErrors = copiedDeal => {
    let copiedDealError = { ...this.state.dealError };
    let hasErrors = false;
    let errors = [];
    if (!copiedDeal.fundId) {
      copiedDealError.fundId = true;
      errors.push(<div>Deals must be assigned a Group.</div>);
      hasErrors = true;
    }
    if (!copiedDeal.name) {
      copiedDealError.name = true;
      errors.push(<div>Deals must have a name.</div>);
      hasErrors = true;
    }
    if (hasErrors) {
      ToastError(
        <div>
          <div>Errors in form: </div>
          {errors}
        </div>
      );
      this.setState({
        dealError: copiedDealError
      });
    }
    return hasErrors;
  };

  save = () => {
    this.setState({
      isNewDeal: true      
    });
    let copiedDeal = { ...this.state.deal };
    let hasErrors = this.handleErrors(copiedDeal);
    if (hasErrors)
      //if there are errors we want to break out of the save logic
      return;
    //using shortid to generate a fake id for properties on a deal since the deal has to be create anew with all of the properties in this case

    const data = { deal: copiedDeal };
    // this is required in order to make create a deal in the database
    data.deal.interestRate = 0;

    this.props.createDeal(data);
  };

  render() {
    const {
      deal,
      isNewDeal,
      isEditing,
      dealError,
      isInitialized,
      showStageField,
      defaultValue
    } = this.state;
    const { theme } = this.props;
    return (
      <Fragment>
        <PaddedContainer>
        <Grid
          container
          alignItems="flex-start"
          justify="flex-start"
          direction="row"
        >
          <Grid item xs={12}>
          <BreadCrumbGrid>
            <OrganicLink to={`/pipeline`}>Pipeline / </OrganicLink>New Deal            
          </BreadCrumbGrid>            
          </Grid>
          <Grid item xs={12}>
            <NewDealHeader saveDeal={() => this.save()} cancel={this.cancel} />
          </Grid>
          <Grid item xs={8}>
            <Styles theme={theme}>
              <div className="form-section" style={{minHeight: '95vh'}}>
                <AssetDetails
                  isNewDeal={isNewDeal}
                  isEditing={isEditing}
                  isInitialized={isInitialized}
                  dealError={dealError}
                  handleChange={this.handleChange}
                  handleTextChange={this.handleTextChange}
                  showStageField={showStageField}
                  defaultValue={defaultValue}
                  deal={deal}
                />
              </div>
            </Styles>
          </Grid>
        </Grid>
        </PaddedContainer>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ deal }) => {
  return { deal };
};

export default compose(
  connect(
    mapStateToProps,
    {
      createDeal,
      addFeatureImageToDeal,
      clearNewDealId
    }
  ),
  withStyles(styles),
  withTheme()
)(NewPipelineDeal);
